// extracted by mini-css-extract-plugin
export default {"wrapper":"JackpotGeneral_wrapper--thS","img":"JackpotGeneral_img--hEb","link":"JackpotGeneral_link--PEa","total":"JackpotGeneral_total--w0O"};